import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    BCTC,
    supportData,
    enterVoiceover,
    auditOpinion,

    chartMaker,
    chiefAccountant,
    certificateNumber,
    accountingService,
    unitHeads,
    dateFounded,
  },
} = checkout;

const validation = Yup.object().shape({
  [taxpayers.name]: Yup.string().required(taxpayers.errorMsg),
  [taxCode.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxCode.invalidMsg)
    .required(taxCode.errorMsg),

  [taxAgentName.name]: Yup.string().optional(),
  [taxAgentCode.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentCode.invalidMsg)
    .optional(),

  [BCTC.name]: Yup.string().required(BCTC.errorMsg),
  [supportData.name]: Yup.string().required(supportData.errorMsg),
  [enterVoiceover.name]: Yup.string().required(enterVoiceover.errorMsg),
  [auditOpinion.name]: Yup.string().required(auditOpinion.errorMsg),

  [chartMaker.name]: Yup.string().required(chartMaker.errorMsg),
  [chiefAccountant.name]: Yup.string().required(chiefAccountant.errorMsg),
  [certificateNumber.name]: Yup.string().required(certificateNumber.errorMsg),
  [accountingService.name]: Yup.string().required(accountingService.errorMsg),
  [unitHeads.name]: Yup.string().required(unitHeads.errorMsg),
  [dateFounded.name]: Yup.number().required(dateFounded.errorMsg),
});

export default validation;
